// Formats an array of toStringable items according to current locale.
function formatArray(inputArray) {
	if (!inputArray || !inputArray.length) return '';

	let array = [...inputArray];
	let last = String(array.pop());
	if (!array.length) return last;

	let first = array.reduce((acc, v) => `${acc}, ${v}`);

	let locale  = localStorage.getItem('locale') || 'no';
	if (locale === 'en') {
		return `${first} and ${last}`;
	}
	return `${first} og ${last}`;
}

export default formatArray;